import React from "react";
import Modal from "../../../../components/shared/modal";
import FuelAddModal from "../../../fuels/add-modal";
import MeterAddModal from "../../../meters/add-modal";
import IncidentsAddModal from "../../../incidents/add-modal";
import ExpensesAddModal from "../../../expenses/add-modal";
import TiresAddModal from "../../../tires/add-modal";
import ServicesAddModal from "../../../services/add-modal";
import ServiceConfigAddModal from "../../../services/service-config-add-modal";
import RenewalAddModal from "../../../../pages/renewals/add-modal";

const VehicleViewModals = ({
    activeTab,
    openFuelAddModal,
    openMeterAddModal,
    openRenewalAddModal,
    openIncidentAddModal,
    openExpenseAddModal,
    openServicesAddModal,
    openServiceConfigAddModal,
    setOpenServiceConfigAddModal,
    handleCloseAddModal,
    handleAddItem,
    handleOpenEditModal,
    vehicle,
    users,
    vehicles,
    vendors,
    renewalTypes,
    meterTypes,
    fetchTabData,
    typesOptions,
    serviceTypesOptions,
    serviceConfigTypesOptions,
    accountId,
    categories,
    paymentMethods,
    jobsOptions
}) => {
    const isModalOpen = openFuelAddModal || openMeterAddModal || openRenewalAddModal || openIncidentAddModal || openExpenseAddModal || openServicesAddModal || openServiceConfigAddModal;


    const renderModalContent = () => {
        switch (activeTab) {
            case "Fuels":
                return (
                    <FuelAddModal
                        handleCloseAddModal={handleCloseAddModal}
                        onAdd={handleAddItem}
                        openEditModal={handleOpenEditModal}
                        vehicle={vehicle}
                        isVehicleEditable={false}
                        spendors={users}
                        vehicles={vehicles}
                        vendors={vendors}
                        fetchFuels={fetchTabData}
                    />
                );
            case "Meters":
                return (
                    <MeterAddModal
                        handleCloseAddModal={handleCloseAddModal}
                        onAdd={handleAddItem}
                        openEditModal={handleOpenEditModal}
                        vehicle={vehicle}
                        isVehicleEditable={false}
                        vehicles={vehicles}
                        types={meterTypes}
                        fetchMeters={fetchTabData}
                    />
                );
            case "Incidents":
                return (
                    <IncidentsAddModal
                        handleCloseAddModal={handleCloseAddModal}
                        onAdd={handleAddItem}
                        openEditModal={handleOpenEditModal}
                        vehicle={vehicle}
                        isVehicleEditable={false}
                        typesOptions={typesOptions}
                        drivers={users}
                        vehicles={vehicles}
                        accountId={accountId}
                        fetchIncidents={fetchTabData}
                    />
                );
            case "Renewals":
                return (
                    <RenewalAddModal
                        handleCloseAddModal={handleCloseAddModal}
                        onAdd={handleAddItem}
                        openEditModal={handleOpenEditModal}
                        vendors={vendors}
                        vehicles={vehicles}
                        fetchRenewals={fetchTabData}
                        types={renewalTypes}
                        context={'create'}
                        vehicle={vehicle}
                    />
                );
            case "Expenses":
                return (
                    <ExpensesAddModal
                        handleCloseAddModal={handleCloseAddModal}
                        onAdd={handleAddItem}
                        openEditModal={handleOpenEditModal}
                        vehicle={vehicle}
                        isVehicleEditable={false}
                        spendors={users}
                        vehicles={vehicles}
                        vendors={vendors}
                        fetchExpenses={fetchTabData}
                        categories={categories}
                        paymentMethods={paymentMethods}
                        jobsOptions={jobsOptions}
                    />
                );
            case "Services":
                return (
                    <ServicesAddModal
                        handleCloseAddModal={handleCloseAddModal}
                        onAdd={handleAddItem}
                        openEditModal={handleOpenEditModal}
                        vehicle={vehicle}
                        isVehicleEditable={false}
                        vehicles={vehicles}
                        vendors={vendors}
                        types={serviceTypesOptions}
                        fetchServices={fetchTabData}
                    />
                );
            case "ServiceConfig":
                return (
                    <ServiceConfigAddModal
                        handleCloseAddModal={handleCloseAddModal}
                        onAdd={handleAddItem}
                        openEditModal={handleOpenEditModal}
                        vehicle={vehicle}
                        isVehicleEditable={false}
                        vehicles={vehicles}
                        serviceTypes={serviceTypesOptions}
                        triggerTypes={serviceConfigTypesOptions}
                        fetchServiceConfig={fetchTabData}
                    />
                );
            case "Tires":
                return (
                    <TiresAddModal
                        handleCloseAddModal={handleCloseAddModal}
                        onAdd={handleAddItem}
                        openEditModal={handleOpenEditModal}
                        vehicle={vehicle}
                        isVehicleEditable={false}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <Modal
            isOpen={isModalOpen}
            onClose={handleCloseAddModal}
            modalClass={"xl:w-[40%] lg:w-[45%] md:w-[65%] sm:w-[70%] w-[90%] !px-0"}
        >
            {renderModalContent()}
        </Modal>
    );
};

export default VehicleViewModals; 